var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConvergence3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9166_3544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1875 18.0156L5.96875 5.80469C5.73438 5.57031 5.73438 5.16406 5.96875 4.92969C6.21094 4.6875 6.61719 4.6875 6.85938 4.92969L19.0703 17.1406C19.3125 17.3828 19.3047 17.7812 19.0703 18.0156C18.8359 18.2656 18.4375 18.2656 18.1875 18.0156ZM16.0469 12.7188L11.1484 7.82031L17.1328 5.05469C18.4141 4.46094 19.4453 5.36719 18.8359 6.6875L16.0469 12.7188ZM8.03125 9.25L14.6094 15.8359L13.0859 19.125C12.4922 20.4062 10.8438 20.1016 10.8438 18.7812L10.8359 13.1641C10.8359 13.0547 10.8047 13.0391 10.7031 13.0391L5.05469 13.0156C3.70312 13.0078 3.46094 11.3594 4.63281 10.8203L8.03125 9.25Z",
    fill: "white",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9166_3544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvergence3);
export default __webpack_public_path__ + "static/media/convergence3.4cbf208fd19952f96637239b38b1b149.svg";
export { ForwardRef as ReactComponent };